export default {"src":"/_next/static/media/brawl-gems.8282f018.svg","height":56,"width":78,"blurWidth":0,"blurHeight":0};